import { h } from 'preact'
import { createDefaultSrc, createPmdSrcSet } from '../pmd/pmd-urls'
import { AnimatedImage } from '../animated-image'
import { stringToArray } from '../utils'
// types
import { ContentType, SectionType } from '../domain'
// styles
import styles from './index.module.css'
import { PullQuote } from '../pull-quote'
import { InlineQuote } from '../inline-quote'
import { Asterism } from '../asterism'
import { Flight } from '../flight'
import { MapOfSomalia } from '../map-somalia'
import { Faktaboks } from '../faktaboks'
import { Mur } from '../mur'

type SectionProps = {
  section: SectionType
}

function getPlacementClass(element) {
  switch (element.value.placement) {
    case 'full-width':
      return styles.fullWidth
    case 'medium-width':
      return styles.mediumWidth
    case 'text-right':
      return styles.textRight
    case 'large-right':
      return styles.largeRight
    case 'right':
      return styles.right
    case 'left':
      return styles.left
    default:
      return ''
  }
}

function getMarginClass(element) {
  switch (element.value.margin) {
    case 'less':
      return styles.marginLess
    case 'big':
      return styles.marginBig
    default:
      return ''
  }
}

export function Section(props: SectionProps) {
  const { section } = props
  return (
    <section className={styles.section}>
      {section.value.introbilde && (
        <figure className={styles.introImage}>
          <img
            src={createDefaultSrc(section.value.introbilde)}
            srcSet={createPmdSrcSet(section.value.introbilde)}
            style={{ width: '100%' }}
            alt=""
          />
        </figure>
      )}

      <h2>{section.value.inngang}</h2>
      {section.value.text &&
        section.value.text.map((element: ContentType, idx) => {
          if (element.type === 'text') {
            return <p key={idx} dangerouslySetInnerHTML={{ __html: element.value }} />
          } else if (element.type === 'pullQuote') {
            return (
              <PullQuote
                key={idx}
                quoteText={element.value.quoteText}
                quoteSource={element.value.quoteSource}
              />
            )
          } else if (element.type === 'inlineQuote') {
            return <InlineQuote key={idx} text={element.value.text} />
          } else if (element.type === 'image') {
            return (
              <figure
                key={idx}
                className={`${getPlacementClass(element)} ${getMarginClass(element)}`}
                style={{ shapeOutside: element.value.shapeOutside || '' }}
              >
                <img
                  src={createDefaultSrc(element.value.fileName)}
                  srcSet={createPmdSrcSet(element.value.fileName)}
                  style={{ width: '100%' }}
                  alt={element.value.alt || ''}
                />
              </figure>
            )
          } else if (element.type === 'animatedImage') {
            return (
              <figure
                className={`${getPlacementClass(element)} ${getMarginClass(element)}`}
                key={idx}
                aria-label={element.value.alt || ''}
                style={{ shapeOutside: element.value.shapeOutside || '' }}
              >
                <AnimatedImage
                  fileName={element.value.fileName}
                  sequence={stringToArray(element.value.sequence)}
                  aspectRatio={parseFloat(element.value.aspectRatio)}
                />
              </figure>
            )
          } else if (element.type === 'asterism') {
            return <Asterism key={idx} />
          } else if (element.type === 'flight') {
            return <Flight key={idx} />
          } else if (element.type === 'mapSomalia') {
            return <MapOfSomalia key={idx} />
          } else if (element.type === 'mur') {
            return <Mur key={idx} />
          } else if (element.type === 'faktaboks') {
            return (
              <Faktaboks
                key={idx}
                id={element.value.id}
                title={element.value.tittel}
                text={element.value.text}
              />
            )
          } else {
            return <pre key={idx}>{JSON.stringify(element, null, 2)}</pre>
          }
        })}
    </section>
  )
}
